import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-background">
                <div className="text-muted-foreground text-sm font-mono">
                    Loading…
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <Navigate
                to={`/login?next=${encodeURIComponent(location.pathname)}`}
                replace
            />
        );
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/panel" replace />;
    }

    return children;
}

export default ProtectedRoute;
